module.exports = __webpack_public_path__ + "static/media/pwc.18abee13.png";